// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

import "prismjs/themes/prism.css"
import "prismjs/plugins/command-line/prism-command-line.css"
import "./global.css"